import { PagedSearch } from '../../shared/model/paged-search.model';

export class ProfileRelationSearch extends PagedSearch {
  ProfileId: number;
  RelProfileID: number;
  RelationID: number;
  PaysInvoices: boolean;
  MainContact: boolean;
  BillingContact: boolean;
  IsEditor: boolean;
  ReceivesCommunication: boolean;
  ReportName: string;
  Title: string;
  Email: string;
  WorkPhone: string;
  RelationType: string;
  InvRelationType: string;

  public constructor() {
    super();

    this.ProfileId = 0;
  }
}
